import React, { Component } from 'react'
import { FormattedMessage } from 'react-intl'
import Link from 'redux-first-router-link'

import styles from './Tags.css'

class Tag extends Component {
  constructor(props) {
    super(props)
    this.handleClick = this.handleClick.bind(this)
  }
  handleClick() {
    const { onFollow, onUnfollow, tag, gaTagFollow } = this.props
    if (tag.following) {
      onUnfollow(tag._id)
    } else {
      onFollow(tag._id)
    }
  }
  render() {
    const { tag, onFollow: canFollow, intl } = this.props
    let stateStyle = tag.following
      ? `${styles.state} ${styles.following}`
      : `${styles.state} ${styles.follow}`
    if (tag.updating) {
      stateStyle = `${stateStyle} ${styles.updating}`
    }
    return (
      <div className={styles.tag}>
        <Link
          className={styles.main}
          to={{
            type: 'home/news/tag/posts',
            payload: {
              tag: tag._id
            },
            meta: {
              push: true
            }
          }}
        >
          <span>{tag._id}</span>
        </Link>
        {canFollow ? (
          <span className={stateStyle} onClick={this.handleClick}>
            {tag.following ? (
              <FormattedMessage id="tags.following" />
            ) : (
              <FormattedMessage id="tags.follow" />
            )}
          </span>
        ) : null}
      </div>
    )
  }
}


const Tags = ({ tags, onFollow, onUnfollow, intl }) => {
  return (
    <div className={styles.tags}>
      {tags.map(t => (
        <Tag
          key={t._id}
          tag={t}
          onFollow={onFollow}
          onUnfollow={onUnfollow}
          intl={intl}
        />
      ))}
    </div>
  )
}


export default Tags
